import { Action, ActionsHubBase } from "DistributedTaskControls/Common/Actions/Base";
import {
    ActionKeys
} from "DistributedTaskControls/SharedControls/InputControls/RepositoryPickerConstants";
import { IRepositorySelectorState } from "DistributedTaskControls/stores/RepositorySelectorStore";

export class RepositorySelectorActions extends ActionsHubBase {
    public initialize(): void {
        this._updateState = new Action<IRepositorySelectorState>();
    }

    public get updateState(): Action<IRepositorySelectorState> {
        return this._updateState;
    }

    public static getKey(): string {
        return ActionKeys.RepositorySelector;
    }

    private _updateState: Action<IRepositorySelectorState>;
}
